'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PublishButton = require('./components/PublishButton.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_PublishButton).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/publish-button/index.js
// module id = 921
// module chunks = 0